import { trackBookingInteraction } from '@/core/services/ga4/ga4-service';
import isBookingDetailPathname from '@/core/utils/is-booking-detail-pathname';

export const POST_BOOKING_GA4_CONTEXT_KEY = 'mindoasis_post_booking_ga4_context';

export type BookingGa4FlowType = 'new' | 'change';

export type PostBookingGa4Context = BookingGa4FlowType;

export type BookingSidebarContext = 'thank-you' | 'booking-detail';

const getThankYouPagePath = (flowType: BookingGa4FlowType): string =>
  `/booking/${flowType}/thank-you`;

export const setPostBookingGa4Context = (
  flowType: PostBookingGa4Context,
): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(POST_BOOKING_GA4_CONTEXT_KEY, flowType);
};

export const getPostBookingGa4Context = (): PostBookingGa4Context | null => {
  if (typeof sessionStorage === 'undefined') return null;
  const value = sessionStorage.getItem(POST_BOOKING_GA4_CONTEXT_KEY);
  if (value === 'new' || value === 'change') return value;
  return null;
};

export const clearPostBookingGa4Context = (): void => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(POST_BOOKING_GA4_CONTEXT_KEY);
};

export const shouldSkipBookingDetailPageView = (pathname: string): boolean =>
  isBookingDetailPathname(pathname) && getPostBookingGa4Context() !== null;

export const trackBookingSidebarInteraction = (
  context: BookingSidebarContext,
  clickText: string | null,
  flowType?: BookingGa4FlowType,
): void => {
  if (context === 'thank-you') {
    const resolvedFlowType = flowType ?? getPostBookingGa4Context() ?? 'new';
    trackBookingInteraction({
      interaction_type: 'click',
      content_name: 'menu click - thank you',
      page_path: getThankYouPagePath(resolvedFlowType),
      click_text: clickText?.toLowerCase() ?? null,
    });
    return;
  }

  trackBookingInteraction({
    interaction_type: 'click',
    content_name: 'menu click - booking detail',
    page_path: '/bookings',
    click_text: clickText?.toLowerCase() ?? null,
  });
};
